module.exports = __webpack_public_path__ + "img/guest-one-time.4a4132c5.svg";